import { useState } from "react";
import ThirdPartyLayout from "../ThirdPartyLayout";
import "../../../../styles/dashboard/third-party/ThirdPartyIndex.css";
import CurrencyText from "../../../../components/fragment/cur-text/CurrencyText";
import { RazorNumberFormat } from "../../../../components/razor-reuse";
import { ALL_ICONS } from "../../../../assets/icons/AllIcons";
import { useSelector } from "react-redux";
import RootState from "../../../../redux/type";
import BridgePaymentDetailsModal from "./BridgePaymentDetailsModal";

const BridgeIndex = () => {
  const [displayDetails, setDisplayDetails] = useState<{
    modal: boolean;
    payment_details?: Record<string, string | string[]> | null;
  }>({
    modal: false,
    payment_details: null,
  });
  const { bridge } = useSelector((state: RootState) => state.thirdParty);

  const CARD_THEMES = [
    "linear-gradient(135deg, #065f46 0%, #059669 100%)",
    "linear-gradient(135deg, #734792 0%, #a855f7 100%)",
    "linear-gradient( to bottom , #263180 0%, #5063DB 60%, #5063DB 90% )",
    "linear-gradient(135deg, #0f172a 0%, #1e3a5f 100%)",
  ];

  return (
    <>
      <ThirdPartyLayout
        titleText="Here are the details about your bridge account"
        title="Bridge Account"
      >
        <div className="blaze-index-wrapper-box-third-party">
          {bridge?.map((chi: any, idx: number) => {
            return (
              <div
                style={{ background: CARD_THEMES[idx % CARD_THEMES.length] }}
                key={idx}
                className="card-amount-box"
              >
                <CurrencyText
                  imgSize={`3rem`}
                  text={chi?.currency?.name + " Wallet"}
                  className="currency-text-box"
                  currency={chi?.currency?.code}
                />
                <div className="label-value-box">
                  <p className="label">{`Current Balance`}</p>
                  <p className="value">
                    {RazorNumberFormat(chi?.wallet?.balance, {
                      symbol: chi?.wallet?.display_currency,
                    })}
                  </p>
                </div>
                <div className="flex items-center justify-between">
                  {chi?.wallet?.usdb_total && (
                    <div className="label-value-box">
                      <p className="label">USDB Total</p>
                      <p className="font-medium text-[20px]!">
                        {RazorNumberFormat(chi?.wallet?.usdb_total, {
                          hideSymbol: true,
                        })}
                      </p>
                    </div>
                  )}
                  {chi?.wallet?.gbp_rate && (
                    <div className="label-value-box">
                      <p className="label">Rate</p>
                      <p className="font-medium text-[20px]!">
                        {chi?.wallet?.gbp_rate || "---"}
                      </p>
                    </div>
                  )}
                </div>
                {/* btn action box start  */}
                <div className="btn-action-box">
                  <div
                    style={{ backgroundColor: chi?.btnBg }}
                    className="btn-wrap"
                    onClick={() => {
                      setDisplayDetails({
                        modal: true,
                        payment_details: chi?.payment_details,
                      });
                    }}
                  >
                    <div className="icon-wrap">
                      <figure className="img-box">
                        {ALL_ICONS?.fund_icon}
                      </figure>
                    </div>
                    <p className="text">Fund</p>
                  </div>
                </div>
                {/* btn action box end */}
              </div>
            );
          })}
        </div>
      </ThirdPartyLayout>
      <BridgePaymentDetailsModal
        visible={displayDetails?.modal}
        onClose={() => {
          setDisplayDetails({
            modal: false,
            payment_details: null,
          });
        }}
        payment_details={displayDetails.payment_details}
      />
    </>
  );
};

export default BridgeIndex;
